import { GDFHotPollyShape, GDFHotPollyTypes, GDFPalletCode } from '../../../gdf/type';
import { getPalette } from '../../../palettes/palettes';
import { generateColorExpressionFromPalette } from '../../../utils/ramp';
import { StyleFactory } from '../styling';

export const volcanicAsh: StyleFactory = (baseId, settings, productId, isLight) => {
    const colorExpr = generateColorExpressionFromPalette(getPalette(GDFPalletCode.volcash, settings, isLight)!, ['get', 'c']);

    return [
        {
            id: baseId + '-cloud-fill',
            source: baseId,
            filter: ['==', ['get', 't'], 'c'],
            type: 'fill',
            paint: {
                'fill-color': 'rgb(255, 255, 255)',
                'fill-opacity': ['global-state', 'polygon-transparency']
            }
        },
        {
            minzoom: 4,
            id: baseId + '-cloud-outline',
            source: baseId,
            filter: ['==', ['get', 't'], 'c'],
            type: 'line',
            paint: {
                'line-color': '#eee',
                'line-width': ['interpolate', ['linear'], ['zoom'], 4, 1, 6, 2]
            }
        },
        {
            minzoom: 4,
            id: baseId + '-cloud-label',
            source: baseId,
            filter: ['==', ['get', 't'], 'c'],
            type: 'symbol',
            layout: {
                'text-ignore-placement': true,
                'text-field': ['get', 'name'],
                'text-anchor': 'bottom',
                'text-font': ['Open Sans Regular'],
                'text-size': 10,
                'text-offset': [0, 0],
                'symbol-placement': 'line'
            },
            paint: {
                'text-color': ['global-state', 'text-color']
            }
        },
        {
            id: baseId + '-icon',
            source: baseId,
            type: 'symbol',
            filter: ['==', ['get', 't'], 'v'],
            pickable: true,
            layout: {
                'icon-image': ['image', 'fe-weather:volcano-filled'],
                'icon-allow-overlap': true
            },
            paint: {
                'icon-color': colorExpr
            }
        },
        {
            themed: true,
            minzoom: 2,
            id: baseId + '-name',
            source: baseId,
            filter: ['==', ['get', 't'], 'v'],
            type: 'symbol',
            layout: {
                'icon-image': ['image', isLight ? 'rect-outline' : 'rect-outline-dark'],
                'icon-text-fit': 'both',
                'icon-text-fit-padding': [1, 1, 1, 1],
                'text-allow-overlap': true,
                'icon-allow-overlap': true,
                'text-field': ['get', 'name'],
                'text-anchor': 'top',
                'text-font': ['Open Sans Regular'],
                'text-size': 10,
                'text-offset': [0, 2.0]
            },
            paint: {
                'text-color': ['global-state', 'text-color'],
                'icon-color': ['global-state', 'text-color']
            }
        }
    ];
};

export const volcanicAsh2: StyleFactory = (baseId, settings, productId, isLight) => {
    const colorExpr = generateColorExpressionFromPalette(getPalette(GDFPalletCode.volcash, settings, isLight)!, ['get', 'c']);

    return [
        {
            pickable: true,
            id: baseId + '-cloud-fill',
            source: baseId,
            filter: ['==', ['get', 't'], 'c'],
            type: 'fill',
            paint: {
                // prettier-ignore
                'fill-color': ["case", 
                    ["<", ["get", "c"], 200], 'rgb(164,208,253)',
                    ["<", ["get", "c"], 500], 'rgb(254, 155, 42)',
                    ["<", ["get", "c"], 1000], 'rgb(255, 33, 25)',
                    [">=", ["get", "c"], 1000], 'rgb(177,0,166)',
                    'rgb(255, 255, 255)'],
                'fill-opacity': ['global-state', 'polygon-transparency']
            }
        },
        {
            id: baseId + '-cloud-outline',
            source: baseId,
            filter: ['==', ['get', 't'], 'c'],
            type: 'line',
            paint: {
                // prettier-ignore
                'line-color': ["case", 
                    ["<", ["get", "c"], 200], 'rgb(164,208,253)',
                    ["<", ["get", "c"], 500], 'rgb(254, 155, 42)',
                    ["<", ["get", "c"], 1000], 'rgb(255, 33, 25)',
                    [">=", ["get", "c"], 1000], 'rgb(177,0,166)',
                    'rgb(255, 255, 255)']
            }
        },
        {
            minzoom: 4,
            id: baseId + '-cloud-label',
            source: baseId,
            filter: ['==', ['get', 't'], 'c'],
            type: 'symbol',
            layout: {
                'text-ignore-placement': true,
                'text-field': ['get', 'name'],
                'text-anchor': 'bottom',
                'text-font': ['Open Sans Regular'],
                'text-size': 10,
                'text-offset': [0, 0],
                'symbol-placement': 'line'
            },
            paint: {
                'text-color': ['global-state', 'text-color']
            }
        },
        {
            id: baseId + '-icon',
            source: baseId,
            type: 'symbol',
            filter: ['==', ['get', 't'], 'v'],
            pickable: true,
            layout: {
                'icon-image': ['image', 'fe-weather:volcano-filled'],
                'icon-allow-overlap': true
            },
            paint: {
                'icon-color': colorExpr
            }
        },
        {
            themed: true,
            minzoom: 2,
            id: baseId + '-name',
            source: baseId,
            filter: ['==', ['get', 't'], 'v'],
            type: 'symbol',
            layout: {
                'icon-image': ['image', isLight ? 'rect-outline' : 'rect-outline-dark'],
                'icon-text-fit': 'both',
                'icon-text-fit-padding': [1, 1, 1, 1],
                'text-allow-overlap': true,
                'icon-allow-overlap': true,
                'text-field': ['get', 'name'],
                'text-anchor': 'top',
                'text-font': ['Open Sans Regular'],
                'text-size': 10,
                'text-offset': [0, 2.0]
            },
            paint: {
                'text-color': ['global-state', 'text-color'],
                'icon-color': ['global-state', 'text-color']
            }
        },
        {
            type: 'fill',
            source: baseId,
            id: baseId + '-hover',
            filter: ['==', ['get', 't'], 'c'],
            paint: {
                'fill-color': ['case', ['boolean', ['feature-state', 'hover'], false], 'rgba(0,0,0,0.22)', 'rgba(0,0,0,0)']
            }
        }
    ];
};

export const tropicalCyclones: StyleFactory = (baseId, settings, productId) => {
    // 1 - depression
    // 2 - tropical storm
    // 3 - hurricane

    const windsColor = generateColorExpressionFromPalette(getPalette(GDFPalletCode.tropical, settings)!, ['get', 'severity']);
    return [
        {
            id: baseId + '-lines',
            source: baseId,
            type: 'line',
            filter: ['==', ['get', 'type'], GDFHotPollyTypes.tropical_stomr_path],
            paint: {
                'line-width': 2,
                'line-color': '#c10400'
            }
        },
        {
            id: baseId + '-wind',
            pickable: true,
            source: baseId,
            type: 'fill',
            filter: ['==', ['get', 'type'], GDFHotPollyTypes.wind_field],
            paint: {
                'fill-color': windsColor,
                'fill-opacity': ['global-state', 'polygon-transparency']
            }
        },
        {
            id: baseId + '-cyclones',
            pickable: true,
            source: baseId,
            filter: ['all', ['==', ['get', 'type'], GDFHotPollyTypes.tropical_cyclone], ['==', ['get', 'id'], 2]],
            type: 'symbol',
            layout: {
                'icon-image': ['image', 'fe-weather:tropical-storm'],
                'icon-allow-overlap': true
            },
            paint: {
                'icon-color': '#c10400'
            }
        },
        {
            id: baseId + '-hurricanes',
            pickable: true,
            source: baseId,
            filter: ['all', ['==', ['get', 'type'], GDFHotPollyTypes.tropical_cyclone], ['==', ['get', 'id'], 3]],
            type: 'symbol',
            layout: {
                'icon-image': ['image', 'fe-weather:tropical-hurricane'],
                'icon-allow-overlap': true
            },
            paint: {
                'icon-color': '#c10400'
            }
        },
        {
            id: baseId + '-depression',
            pickable: true,
            source: baseId,
            filter: ['all', ['==', ['get', 'type'], GDFHotPollyTypes.tropical_cyclone], ['==', ['get', 'id'], 1]],
            type: 'symbol',
            layout: {
                'text-field': 'L',
                'text-font': ['Open Sans Regular'],
                'text-allow-overlap': true,
                'text-size': 20
            },
            paint: {
                'text-color': '#c10400'
            }
        }
    ];
};

export const tropopauseLowsLayers: StyleFactory = (baseId, settings, productId) => {
    return [
        {
            id: baseId + '-labels',
            source: baseId,
            type: 'symbol',
            layout: {
                'icon-image': ['image', 'tropo-shield'],
                'icon-text-fit': 'both',
                'icon-text-fit-padding': [2, 2, 4, 2],
                'text-line-height': 0.9,
                'text-allow-overlap': true,
                'icon-allow-overlap': true,
                'text-ignore-placement': true,
                'text-field': ['format', ['get', 'tops'], ['literal', '\nL']],
                'text-anchor': 'center',
                'text-font': ['Open Sans Regular'],
                'text-size': 10,
                'text-offset': [0, 0],
                'icon-pitch-alignment': 'map',
                'text-pitch-alignment': 'map'
            },
            paint: {
                'text-color': ['global-state', 'text-color']
            }
        }
    ];
};

export const tropopauseHeightsLayers: StyleFactory = (baseId) => {
    return [
        {
            id: baseId + '-fill',
            source: baseId,
            type: 'fill',
            paint: {
                'fill-color': '#444',
                'fill-opacity': ['global-state', 'polygon-transparency']
            }
        },
        {
            id: baseId + '-outline',
            source: baseId,
            type: 'line',
            paint: {
                'line-color': '#444',
                'line-width': 1
            }
        },
        {
            id: baseId + '-labels',
            source: baseId,
            type: 'symbol',
            filter: ['==', ['geometry-type'], 'Point'],
            layout: {
                'icon-image': ['image', 'tropo-shield'],
                'icon-text-fit': 'both',
                'icon-text-fit-padding': [2, 2, 4, 2],
                'text-line-height': 0.9,
                'text-allow-overlap': true,
                'icon-allow-overlap': true,
                'text-ignore-placement': true,
                'text-field': ['format', ['get', 'tops'], ['literal', '\nH']],
                'text-anchor': 'center',
                'text-font': ['Open Sans Regular'],
                'text-size': 10,
                'text-offset': [0, 0],
                'icon-pitch-alignment': 'map',
                'text-pitch-alignment': 'map',
                'symbol-placement': 'point'
            },
            paint: {
                'text-color': ['global-state', 'text-color']
            }
        }
    ];
};

export const weatherDepictionLayers: StyleFactory = (baseId) => {
    return [
        {
            id: baseId + '-line',
            source: baseId,
            type: 'line',
            paint: {
                'line-color': 'rgb(115, 238, 0)',
                'line-width': 1
            }
        }
    ];
};

export const freezingLevelsLayers: StyleFactory = (baseId) => {
    return [
        {
            id: baseId + '-line',
            source: baseId,
            type: 'line',
            paint: {
                'line-color': 'rgba(0, 36, 238, 1)',
                'line-width': 1
            }
        },
        {
            minzoom: 2,
            id: baseId + '-symbol',
            source: baseId,
            type: 'symbol',
            layout: {
                'text-allow-overlap': true,
                'text-field': ['get', 'label'],
                'text-anchor': 'bottom',
                'text-font': ['Open Sans Regular'],
                'text-size': 10
            },
            paint: {
                'text-color': ['global-state', 'text-color'],
                'text-halo-width': 0.25,
                'text-halo-color': 'rgba(0,0,0,0.33)'
            }
        }
    ];
};

export const watchesWarningLayers: StyleFactory = (baseId) => {
    return [
        {
            id: baseId + '-line',
            source: baseId,
            type: 'line',
            paint: {
                // prettier-ignore
                'line-color': [
                    'case',
                    ['==', ['get', 'type'], GDFHotPollyTypes.watch_tstorm], '#ffff01',
                    ['==', ['get', 'type'], GDFHotPollyTypes.watch_tornado], '#ff0000',
                    ['==', ['get', 'type'], GDFHotPollyTypes.warning_tstorm], '#fa7d00',
                    ['==', ['get', 'type'], GDFHotPollyTypes.warning_tornado], '#990001',
                    'transparent'
                ],
                'line-width': 1
            }
        },
        {
            id: baseId + '-fill',
            pickable: true,
            source: baseId,
            type: 'fill',
            paint: {
                // prettier-ignore
                'fill-color': [
                    'case',
                    ['==', ['get', 'type'], GDFHotPollyTypes.watch_tstorm], '#ffff01',
                    ['==', ['get', 'type'], GDFHotPollyTypes.watch_tornado], '#ff0000',
                    ['==', ['get', 'type'], GDFHotPollyTypes.warning_tstorm], '#fa7d00',
                    ['==', ['get', 'type'], GDFHotPollyTypes.warning_tornado], '#990001',
                    'transparent'
                ],
                'fill-opacity': ['global-state', 'polygon-transparency']
            }
        },
        {
            minzoom: 4,
            id: baseId + '-symbol',
            source: baseId,
            filter: ['==', ['geometry-type'], 'Point'],
            type: 'symbol',
            layout: {
                'text-font': ['Open Sans Regular'],
                'text-size': 10,
                'text-field': ['get', 'label'],
                'text-allow-overlap': true,
                'text-anchor': 'top',
                'text-offset': [0, 0.25],
                'symbol-placement': 'point'
            },
            paint: {
                'text-color': ['global-state', 'text-color']
            }
        }
    ];
};

export const centerWeatherAdvisory: StyleFactory = (baseId) => {
    return [
        {
            type: 'fill',
            source: baseId,
            id: baseId + '-fill',
            pickable: true,
            filter: ['==', ['get', 'shape'], GDFHotPollyShape.polygon],
            paint: {
                'fill-color': [
                    'match',
                    ['get', 'type'],
                    GDFHotPollyTypes.cwa_tstorm,
                    'rgb(128,0,0)',
                    GDFHotPollyTypes.cwa_turb,
                    'rgb(160,96,0)',
                    GDFHotPollyTypes.cwa_icing,
                    'rgb(0,0,128)',
                    GDFHotPollyTypes.cwa_ifr,
                    'rgb(63,0,63)',
                    GDFHotPollyTypes.cwa_precipitation,
                    'rgb(255,0,255)',
                    GDFHotPollyTypes.cwa_unknown,
                    'rgb(139,139,139)',
                    'rgb(139,139,139)'
                ],
                'fill-opacity': ['global-state', 'polygon-transparency']
            }
        },
        {
            type: 'line',
            source: baseId,
            id: baseId + '-fill-outline',
            filter: ['==', ['get', 'shape'], GDFHotPollyShape.polygon],
            paint: {
                'line-color': '#000', // always black
                'line-width': ['interpolate', ['linear'], ['zoom'], 0, 0, 2, 1, 4, 2]
            }
        },
        {
            type: 'fill',
            source: baseId,
            id: baseId + '-hover',
            filter: ['==', ['get', 'shape'], GDFHotPollyShape.polygon],
            paint: {
                'fill-color': ['case', ['boolean', ['feature-state', 'hover'], false], 'rgba(0,0,0,0.22)', 'rgba(0,0,0,0)']
            }
        }
    ];
};
